import React from "react";

export default function WelfareSupremacy() {
  return (
    <section
      data-testid="welfare-supremacy"
      className="bg-[#FAF7EC] border-y border-slate-200"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="brand-rule" />
              <span className="overline">Welfare Supremacy</span>
            </div>
            <h2 className="mt-6 font-display font-black text-3xl md:text-5xl tracking-tight leading-[1.05] text-slate-900">
              The working dog is a living partner — not a tool.
            </h2>
            <blockquote className="mt-8 border-l-2 border-amber-600 pl-6 max-w-md">
              <p className="font-display text-lg md:text-xl leading-snug text-slate-900">
                "Welfare is not a secondary policy consideration. It is the ethical
                ceiling of the entire institution."
              </p>
              <footer className="mt-3 font-mono text-[11px] uppercase tracking-[0.22em] text-slate-600">
                Institutional Bible · Vol. V
              </footer>
            </blockquote>
          </div>

          <div className="col-span-12 md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-8 md:pt-2">
            {[
              {
                t: "Sentience Before Service",
                b: "A dog's well-being supersedes the institution's preferences. The work earns the partner — never the other way around.",
              },
              {
                t: "Biological Stewardship",
                b: "Cumulative-stress monitoring, deliberate recovery windows, and proactive veterinary care are doctrine, not options.",
              },
              {
                t: "Joy Preservation",
                b: "Play, rest, and curiosity are protected with the same discipline as deployment readiness.",
              },
              {
                t: "Humane Training",
                b: "Relationship-led, force-free methods. We measure mastery by the dog's willingness, not its compliance.",
              },
              {
                t: "Lifetime Stewardship",
                b: "Our partners are cared for from selection through retirement — for the entirety of their lives.",
              },
              {
                t: "Longevity as Metric",
                b: "Success is measured in part by the absence of preventable injury or burnout — and the long, dignified service of each partner.",
              },
            ].map((it, i) => (
              <div
                key={it.t}
                data-testid={`welfare-tenet-${i}`}
                className="border-l-2 border-slate-300 pl-5"
              >
                <h3 className="font-display font-bold text-lg text-slate-900">{it.t}</h3>
                <p className="mt-2 text-slate-600 leading-relaxed text-[15px]">{it.b}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
